export const ANNOUNCEMENT_STATUS = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
};

export function timestampToMillis(value) {
  if (!value) return 0;
  if (typeof value.toMillis === 'function') return value.toMillis();
  if (typeof value.toDate === 'function') return value.toDate().getTime();
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0;

  const parsed = new Date(value).getTime();
  return Number.isFinite(parsed) ? parsed : 0;
}

export function sortAnnouncements(announcements = []) {
  return [...announcements].sort((left, right) => {
    const rightTime = timestampToMillis(right.publishedAt || right.createdAt);
    const leftTime = timestampToMillis(left.publishedAt || left.createdAt);
    if (rightTime !== leftTime) return rightTime - leftTime;
    return String(right.id || '').localeCompare(String(left.id || ''));
  });
}

export function getUnreadAnnouncements(announcements = [], readState = {}) {
  const ordered = sortAnnouncements(announcements);
  if (!ordered.length) return [];

  if (readState.lastSeenAnnouncementId === ordered[0].id) {
    return [];
  }

  const lastSeenTime = timestampToMillis(readState.lastSeenPublishedAt);
  if (!lastSeenTime) return ordered;

  return ordered.filter((announcement) => (
    timestampToMillis(announcement.publishedAt || announcement.createdAt) > lastSeenTime
  ));
}

export function normalizeAnnouncementDraft(draft = {}) {
  const bullets = Array.isArray(draft.bullets)
    ? draft.bullets
    : String(draft.bulletsText || '').split('\n');

  return {
    title: String(draft.title || '').trim(),
    summary: String(draft.summary || '').trim(),
    bullets: bullets.map((bullet) => String(bullet).trim()).filter(Boolean).slice(0, 4),
    ctaLabel: String(draft.ctaLabel || '').trim(),
    ctaPath: String(draft.ctaPath || '').trim(),
  };
}

/** Announcement buttons may only go to an in-app path or an https URL (never javascript:, data:, etc.). */
export function isSafeCtaPath(path) {
  const value = String(path || '').trim();
  return (value.startsWith('/') && !value.startsWith('//')) || /^https:\/\/[^\s]+$/i.test(value);
}

export function validateAnnouncementDraft(draft = {}) {
  const normalized = normalizeAnnouncementDraft(draft);
  if (!normalized.title) return 'Add an announcement title.';
  if (!normalized.summary && normalized.bullets.length === 0) {
    return 'Add a short summary or at least one change.';
  }
  if (normalized.ctaLabel && !normalized.ctaPath) {
    return 'Add a destination for the optional button.';
  }
  if (normalized.ctaPath && !isSafeCtaPath(normalized.ctaPath)) {
    return 'The button destination must start with / (in-app page) or https://.';
  }
  return '';
}

export function formatAnnouncementDate(value) {
  const milliseconds = timestampToMillis(value);
  if (!milliseconds) return 'Recently';
  return new Date(milliseconds).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}
